module.exports = __webpack_public_path__ + "static/img/LbTu3@2x.c4646310.png";